module.exports = __webpack_public_path__ + "img/leaf.a8931d37.svg";